import SectionLabel from '../components/SectionLabel'
import BlogCard from '../components/BlogCard'
import WACTASection from '../components/WACTASection'
import { posts } from '../data/blog'

export default function Blog() {
  return (
    <main style={{ background: 'var(--white)' }}>
      <section style={{ background: 'var(--stone)', padding: '100px 5% 60px', textAlign: 'center' }}>
        <SectionLabel>Trekking Insights</SectionLabel>
        <h1 className="serif" style={{ fontSize: '48px', fontWeight: 600, marginBottom: '16px' }}>The Nepal Guide.</h1>
        <p style={{ color: 'var(--ink-mid)', maxWidth: '520px', margin: '0 auto', fontSize: '15px', fontWeight: 300 }}>
          Everything you need to know about trekking in Nepal, from permit updates to the best peaks for solitude.
        </p>
      </section>

      <section className="section">
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
          gap: '32px' 
        }}>
          {posts.map(post => (
            <BlogCard key={post.slug} post={post} />
          ))}
        </div>
      </section>

      <WACTASection />
    </main>
  )
}
